<template>
  <div class="overlay">
    <div class="pratos-container insidePlateData">
      <div class="pt-title" v-text="title"></div>
      <div class="pt-header">
        <span
          v-for="(pt, key) in errors[0]"
          v-text="pt"
          v-if="key != 'desc' && key != 'utilizacao' && key != 'gpprato' && key != 'agpprato'"
        ></span>
      </div>
      <div class="pt-body">
        <div class="pratos" v-for="pratos in errors" :class="{highLightRed: pratos.highLightRed}">
          <span v-for="(ptData, key) in pratos" v-if="!['COD_PRATO_OR', 'highLightRed'].includes(key)" v-text="ptData"></span>
        </div>
      </div>
      <div class="pt-footer">
        <button class="button gray-button" @click="exportToExcel">
          <i class="fas fa-file-excel"></i>
          <span>{{$t('export')}}</span>
        </button>
        <div class="right-container">
          <button class="button gray-button" @click="chooseAction(false)">
            <i class="fas fa fa-ban"></i>
            <span>{{$t('cancel')}}</span>
          </button>
          <button class="button gray-button" @click="chooseAction(true)">
            <i class="fas fa fa-forward"></i>
            <span>{{$t('continue')}}</span>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Util from "@/application/libs/util";
import ExcelBuilder from "@/application/libs/excelBuilder";
import { t } from 'i18next'

export default {
  name: "UnconsideredPlatesList",
  props: ["dataFromOtm"],
  data() {
    return {
      errors: [],
      title: t('inconsistencies_alert_dishes_that_will_be_disregarded')
    };
  },
  mounted() {
    this.checkErros();
  },
  methods: {
    chooseAction: function(action) {
        this.$emit("chooseAction", action);
    },
    setArrayForExcell: function(errors) {
      let erroExcell = [];
      let errorWhitoutHeader = Object.assign([], errors);
      errorWhitoutHeader.splice(0, 1);
      return errorWhitoutHeader;
    },
    exportToExcel: function() {
      ExcelBuilder.fromJson(
        this.setArrayForExcell(this.errors),
        [
          { header: t('code'), key: "COD_PRATO" },
          { header: t('name'), key: "NOM_PRATO" },
          { header: t('description'), key: "DESC" }
        ],
        this.title,
        Util.getExcelHeaderFromFilter()
      );
    },
    validaCaracteristicaPrato: function( p ) {
        const errors = [];
        const campos = ['INGR_PRINCIPAL_1', 'INGR_PRINCIPAL_2', 'TP_CORTE', 'MODO_PREPARO'];
        
        const campoInvalido = campos.some(campo => 
          p.hasOwnProperty(campo) && (p[campo] === null || p[campo] === undefined || p[campo] === '')
        );        
        if (campoInvalido) {
          errors.push ({
            COD_PRATO_OR: p.COD_PRATO,
            COD_PRATO:
              p.COD_PRATO[0] == "P"
                ? "P - " + p.COD_PRATO.replace("P", "")
                : "L - " + p.COD_PRATO.substr(4),
            NOM_PRATO: p.NOM_PRATO || p.NMPRATO,
            DESC: t('dish_has_uninformed_characteristic')
          });
        }
        if(p.IDPRODATIVPR === "N"){
          errors.push ({
            COD_PRATO_OR: p.COD_PRATO,
            COD_PRATO:
              p.COD_PRATO[0] == "P"
                ? "P - " + p.COD_PRATO.replace("P", "")
                : "L - " + p.COD_PRATO.substr(4),
            NOM_PRATO: p.NOM_PRATO || p.NMPRATO,
            DESC: t('dish_has_inactive_product')
          });          
        }
        if(p.IDPRODATIV === "I"){
          errors.push ({
            COD_PRATO_OR: p.COD_PRATO,
            COD_PRATO:
              p.COD_PRATO[0] == "P"
                ? "P - " + p.COD_PRATO.replace("P", "")
                : "L - " + p.COD_PRATO.substr(4),
            NOM_PRATO: p.NOM_PRATO || p.NMPRATO,
            DESC: t('dish_has_inactive_product_on_unit')
          });          
        }        
        if(errors.length) return errors;
        else return false
    },
    validaHistoricoAtratividade: function( p, pratoSemHistorico, pratoSemAtratividade ) {
        const errors = [];
        if (pratoSemHistorico.includes(p.COD_PRATO)) {
          errors.push ({
            COD_PRATO_OR: p.COD_PRATO,
            COD_PRATO:
              p.COD_PRATO[0] == "P"
                ? "P - " + p.COD_PRATO.replace("P", "")
                : "L - " + p.COD_PRATO.substr(4),
            NOM_PRATO: p.NOM_PRATO || p.NMPRATO,
            DESC: t('dish_has_no_history_of_consumption')
          });
        }
        if (pratoSemAtratividade.includes(p.COD_PRATO)) {
          errors.push ({
            COD_PRATO_OR: p.COD_PRATO,
            COD_PRATO:
              p.COD_PRATO[0] == "P"
                ? "P - " + p.COD_PRATO.replace("P", "")
                : "L - " + p.COD_PRATO.substr(4),
            NOM_PRATO: p.NOM_PRATO || p.NMPRATO,
            DESC: t('dish_has_no_reported_attractiveness')
          });
        }
        if(errors.length) return errors;
        else return false
    },
    filtrarPratosPorSequencial: function (publicScenario, dataFromOtm) {
      const sequenciaisAlvo = (dataFromOtm.sequencialCenarioOriginal.data || []).map(
        item => item.NRSEQCNFCARDORIG.toString()
      );
      const pratosUnicos = {};
      const pratosFiltrados = (publicScenario.datas || []).flatMap(dia => 
        dia.pratos
          .filter(prato => {
            const isSequencialValido = sequenciaisAlvo.includes(prato.sequencial);
            const isCodpratoNovo = !pratosUnicos[prato.codprato];
            
            if (isSequencialValido && isCodpratoNovo) {
              pratosUnicos[prato.codprato] = true;
              return true;
            }
            return false;
          })
          .map(prato => ({
            codprato: prato.codprato,
            sequencial: prato.sequencial,
            nmprato: prato.nmprato
          }))
      );
      return pratosFiltrados;
    },
    filtrarPratosInvalidos: function(pratoSeq) {
      const backOfficeData = JSON.parse(localStorage.getItem("backOfficeData") || "{}");
      const cdpictprat = backOfficeData.CDPICTPRAT || "aa.aa.aa.aaa";
      const tamanhoMascara = cdpictprat.split('.').join('').length;
      const codigoFilial = Util.getFilterInSession().CDFILIAL || "";
      
      const pratosInvalidos = (pratoSeq || []).filter(prato => {
        const parteInicial = prato.codprato.slice(0, -tamanhoMascara);
        const isInvalido = !parteInicial.startsWith('P') && !parteInicial.startsWith(codigoFilial);
        return isInvalido;
      });
      return pratosInvalidos;
    },
    adicionarErrosDePrato: function(pratos, tipoErro, mensagem, destaqueVermelho = false) {
      pratos.forEach(prato => {
        const codigoFormatado = prato.codprato[0] === "P" 
          ? "P - " + prato.codprato.substring(1) 
          : "L - " + prato.codprato.substring(4);
    
        this.errors.push({
          COD_PRATO_OR: prato.codprato,
          COD_PRATO: codigoFormatado,
          NOM_PRATO: prato.nmprato,
          DESC: this.$t(mensagem),
          highLightRed: destaqueVermelho
        });
      });
    },
    adicionarErro: function(prato, mensagem, destaqueVermelho = false, auxiliar = '') {
      this.errors.push({
        COD_PRATO_OR: prato.COD_PRATO,
        COD_PRATO:
          prato.COD_PRATO[0] == "P"
            ? "P - " + prato.COD_PRATO.replace("P", "")
            : "L - " + prato.COD_PRATO.substr(4),
        NOM_PRATO: prato.NOM_PRATO ? prato.NOM_PRATO : prato.NMPRATO,
        DESC: auxiliar + this.$t(mensagem),
        highLightRed: destaqueVermelho,
      });
    },
    // função para verificar se o produto tem algum campo PROD_DESATU 
    // com valor diferente de N
    verificaAttProd: function(prato) {
      const prodDesatu = [
        prato.PROD_DESATU, 
        prato.PROD_DESATU_1,
        prato.PROD_DESATU_2,
        prato.PROD_DESATU_3
      ].some(v => v === 'N');
      if (prodDesatu) return false;
      return true;
    },
    checkErros: function() {
      let receitaPrato =
        (this.dataFromOtm.receita_prato &&
          this.dataFromOtm.receita_prato.data) ||
        [];
      let plates = [];
      let platesCode = [];
      let pratoSemHistorico =
        (this.dataFromOtm.prato_sem_historico &&
          this.dataFromOtm.prato_sem_historico.data.filter(p => p.TIPO_ERRO === 'HISTORICO')) ||
        [];
      let pratoSemAtratividade =
      (this.dataFromOtm.prato_sem_historico &&
        this.dataFromOtm.prato_sem_historico.data.filter(p => p.TIPO_ERRO === 'ATRATIVIDADE')) ||
      [];
      pratoSemHistorico = pratoSemHistorico.map(p => {
        return p.COD_PRATO;
      });
      pratoSemAtratividade = pratoSemAtratividade.map(p => {
        return p.COD_PRATO;
      });
      let pratosSemGrupo = (this.dataFromOtm.pratos_sem_grupo && this.dataFromOtm.pratos_sem_grupo.data || [])
      let pratosSemCusto4 = new Map();

      const pratosMap = receitaPrato.reduce((acc, p) => {
        (acc[p.COD_PRATO] ||= []).push(p);
        return acc;
      }, {});

      Object.values(pratosMap).forEach(produtosDoPrato => {
        const zerados = produtosDoPrato.filter(p => !p.VLR_PRODUTO || p.VLR_PRODUTO <= 0);

        const produtosParaAdicionar = zerados.length > 0 ? zerados : [produtosDoPrato[0]];

        produtosParaAdicionar.forEach(p => {
          plates.push({
            COD_PRATO: p.COD_PRATO,
            NOM_PRATO: p.NOM_PRATO,
            COD_PRODUTO: p.COD_PRODUTO,
            NOM_PRODUTO: p.NOM_PRODUTO,
            INGR_PRINCIPAL_1: p.INGR_PRINCIPAL_1,
            INGR_PRINCIPAL_2: p.INGR_PRINCIPAL_2,
            TP_CORTE: p.TP_CORTE,
            VLR_PRODUTO: p.VLR_PRODUTO,
            PROD_DESATU: this.verificaAttProd(p),
            MODO_PREPARO: p.MODO_PREPARO,
            IDPRODATIVPR: p.IDPRODATIVPR, 
            IDPRODATIV: p.IDPRODATIV
          });
        });
      });

      pratosSemGrupo.forEach(p => {
        this.adicionarErro(p, 'plate_has_no_linked_group')
      });

      // COD_PRATO, NOM_PRATO, DESCRICAO
      // 1) se VLR_CUSTO_PRATO <= 0, descrição é "Prato possui produto com custo zerado ou desatualizado"
      // 2) se INGR_PRINCIPAL_1, INGR_PRINCIPAL_2, TP_CORTE, MODO_PREPARO is null, descrição é: "Prato possui característica não informada"
      // 3) se esta na lista pratoSemHistorico, Prato não possui histórico de consumo.
      const pratoComReceita = new Map();
      const pratosJaValidadosAtratividade = new Set();

      plates.forEach(p => {
        pratoComReceita.set(p.COD_PRATO);

        // só valida histórico/atratividade/caracteristicas uma vez por prato
        if (!pratosJaValidadosAtratividade.has(p.COD_PRATO)) {
          let errorsHistAtr = this.validaHistoricoAtratividade(p, pratoSemHistorico, pratoSemAtratividade);
          if (errorsHistAtr) {
            this.errors = this.errors.concat(errorsHistAtr);
          }
          pratosJaValidadosAtratividade.add(p.COD_PRATO);

          let error = this.validaCaracteristicaPrato(p);
          if(error) this.errors = this.errors.concat(error);
        }

        if (p.VLR_PRODUTO <= 0 || p.PROD_DESATU) {
          this.adicionarErro(p, 'zero_cost_or_outdated', true, p.NOM_PRODUTO + ' - ');
          pratosSemCusto4.set(p.COD_PRATO);
        }
      });
      //DESCRIÇÃO DE ALERTA
      /**
       * CASO SEQUENCIAL DO PRATO SEJA IGUAL AO NRSEQCNFCARDORIG DENTRO DE sequencialCenarioOriginal
       *    - CASO NÃO COMECE COM P OU CODIGO DA FILIAL
       *    - CASO ESTEJA EM PRATOS SEM GRUPO
       *    - CASO ESTEJA EM PRATOS SEM RECEITA
       */
      let publicScenario = Util.getFilterInSession();
      const IDUTRPADCA = publicScenario.IDUTRPADCA || 'S';
      publicScenario = JSON.parse(publicScenario.parsedCardapio);
      let pratoSeq = this.filtrarPratosPorSequencial(publicScenario, this.dataFromOtm);

      let pratosInvalidos = pratoSeq && pratoSeq.length ? this.filtrarPratosInvalidos(pratoSeq) : [];

      let pratosComErroDeGrupo = (pratoSeq || []).filter(prato => {
        return pratosSemGrupo.some(p => p.COD_PRATO === prato.codprato);
      });
    
      let pratosSemReceita = IDUTRPADCA == 'S'? [] : (pratoSeq || []).filter(prato => {
        return !receitaPrato.some(p => p.COD_PRATO === prato.codprato);
      });

      this.adicionarErrosDePrato(
        pratosComErroDeGrupo,
        'sem_grupo',
        'plate_has_no_linked_group_destiny_unit',
        false
      );
      this.adicionarErrosDePrato(
        pratosSemReceita,
        'sem_receita',
        'plate_has_no_recipe',
        true
      );
      this.adicionarErrosDePrato(
        pratosInvalidos,
        'invalido',
        'invalid_plate_format',
        true
      );

      if (this.errors.length > 0) {
        this.errors.sort((a, b) => {
          if (a.COD_PRATO_OR < b.COD_PRATO_OR) {
            return -1;
          }
          return 1;
        });
        this.errors.unshift({
          COD_PRATO: t('CAPITAL_COD_PLATE'),
          NOM_PRATO: t('CAPITAL_NAME_PLATE'),
          DESC: t('description')
        });
      }
      if(this.errors.length == 1){
        this.$emit("chooseAction", true);
      }
      // Flag para não precisar fazer filter complexo depois.
      this.dataFromOtm.receita_prato.data = this.dataFromOtm.receita_prato.data.map(p => {
        if (pratosSemCusto4.has(p.COD_PRATO)) {
          return { ...p, semCusto: true };
        }
        return p;
      });
    }
  }
};
</script>

<style scoped lang="less">
@import (reference) url("../../assets/variables.less");
.pratos-container {
  font-size: 13px;
  .sombra;
}

.highLightRed {
  color: red;
}
.gray-button {
  margin: 15px 0;
  padding: 5px;
  font-size: 1rem;
  box-shadow: none;
  background-color: #dedede;
  color: #383838;
  &:hover {
    background-color: gray;
    color: white;
  }
}
.right-container {
  float: right;
  .gray-button {
    margin: 15px 7.5px;

    &:last-of-type {
      margin-right: 0;
    }
  }
}

.overlay {
  position: fixed;
  z-index: 10;
  .full;
  background: rgba(0, 0, 0, 0.5);
}
.pt-title {
  position: relative;
  display: block;
  margin: auto;
  text-align: center;
  padding: 15px 0;
  font-size: 16px;
}
.insidePlateData {
  padding: 0 15px;
  position: fixed;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  border-radius: 5px;
  background: white;
  width: 70%;
}
.pt-header {
  height: 34px;
  background: @azul;
  color: #fff;
  display: grid;
  grid-template-columns: 20% 30% 50%;
  span:first-of-type {
    padding-left: 5px;
    margin: auto 0;
  }
  span:not(:first-of-type) {
    text-align: center;
    padding-left: 5px;
    display: table;
    margin: auto;
  }
}
.pt-body {
  padding-bottom: 5px;
  border-bottom: solid 1px rgba(0, 0, 0, 0.5);
  max-height: 50vh;
  overflow: auto;
  .pratos {
    &:first-of-type {
      display: none;
    }
    &:nth-of-type(2n) {
      background: rgba(196, 196, 196, 0.2);
    }
    display: grid;
    grid-template-columns: 20% 30% 50%;
    span {
      margin: auto;
      padding: 5px;
      max-width: 100%;
      text-align: center;
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
      display: block;
    }
    span:first-of-type {
      text-align: left;
      margin: auto 0;
      padding-left: 5px;
      font-size: 13px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    span:not(:first-of-type) {
      text-align: center;
    }
  }
  .lackOfCost {
    color: red;
  }
}
</style>